var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('div',{staticClass:"custom-textarea",class:{
      'is-invalid': _vm.state === false,
      'is-valid': _vm.state === true,
      'not-empty': _vm.value,
    }},[_c('div',{staticClass:"wrap"},[_c('div',{staticClass:"mirror",domProps:{"innerHTML":_vm._s(((_vm.value.replace(/\r\n|\r|\n/g, '<br>')) + "<br>"))}}),_c('textarea',{staticClass:"form-control",class:{
          'is-invalid': _vm.state === false,
          'is-valid': _vm.state === true,
          'not-empty': _vm.value,
        },attrs:{"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)},"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }if(!$event.ctrlKey){ return null; }return _vm.$emit('ctrl_enter')}}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }